<template>
  <div class="boxes">
    <v-card
      v-for="(r, i) in kpis"
      :key="i"
      :loading="loading"
      class="card-color"
    >
      <v-card-text>
        <div class="header">
          <div class="label">
            {{ r.title }}
          </div>
          <div class="value">
            {{ r.value }}
          </div>
        </div>
        <!-- <div class="mt-3 content">
          <div class="sub-text">
            {{ r.subtitle }}
          </div>
        </div> -->
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      loading: "usersAnalyticsDashboard/getLoading",
      items: "usersAnalyticsDashboard/getAggregatedData",
    }),
    kpis() {
      const usr = this.items;
      return [
        {
          title: "Total Users",
          value: usr?.total_users?.value || "0",
          subtitle: `${usr?.total_users?.change_percentage || "0"}%`,
        },
        {
          title: "Total Sessions",
          value: usr?.total_sessions?.value || "0",
          subtitle: `${usr?.total_sessions?.change_percentage || "0"}%`,
        },
        {
          title: "Total Revenue",
          value: `${
            this.$options.filters.commaFormat(
              usr?.total_revenue?.value?.toFixed(0)
            ) || "0"
          }`,
          subtitle: `${usr?.total_revenue?.change_percentage || "0"}%`,
        },
        {
          title: "Avg Session Cost",
          value: `PKR ${usr?.avg_session_cost?.value || "0"}`,
          subtitle: `${usr?.avg_session_cost?.change_percentage || "0"}%`,
        },
        {
          title: "Total kWh Dispensed",
          value: usr?.total_energy_consumed?.value || "0",
          subtitle: `${usr?.total_energy_consumed?.change_percentage || "0"}%`,
        },
        {
          title: "Avg Session Duration",
          value: `${usr?.avg_session_duration_minutes?.value || "0"} min`,
          subtitle: `${
            usr?.avg_session_duration_minutes?.change_percentage || "0"
          }%`,
        },
        {
          title: "Card Revenue %",
          value: `${usr?.card_revenue_percentage?.value || "0"}%`,
          subtitle: `${
            usr?.card_revenue_percentage?.change_percentage || "0"
          }%`,
        },
      ];
    },
  },
  methods: {
    getColor(r) {
      const code = r.severity_level;
      if (["high", "High"].includes(code)) {
        return "red";
      } else if (["medium", "Medium"].includes(code)) {
        return "light-green";
      } else if (["low", "Low"].includes(code)) {
        return "amber";
      } else {
        return "gray";
      }
    },
  },
};
</script>

<style lang="sass" scoped>

.boxes
  display: flex
  // justify-content: space-between
  flex-wrap: wrap
  gap: 1rem


.boxes .v-card
  // flex: 1 1 calc(25% - 16px) /* Adjust the width and spacing as needed */
  flex-basis: 24%// padding: 1rem /* Add some spacing between the cards */

.header
  display: flex
  flex-direction: column
  justify-content: space-between
  gap: 1.5rem
  .label
    font-size: 1rem !important
  .value
    font-size: 2rem !important
    font-weight: 600
    color : $theme-color

.content
    color: #28a745
    div:last-child
        font-size: 0.875rem

.card-color
    border-radius: 10px
    border-left: 0.5rem solid $theme-color !important




@media only screen and (max-width: 960px)
    .boxes
        flex-direction: column
</style>
